import './main.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';
import ReportFileForm from './components/report-file-form';

const Main = renderViewsState(
	props => (
		<Animate>
			<div className="container__content fin-reports">
				<div className="container__content-title">
					<div className="container__content-title-position">
						<h1 className="title">{props.intl('Landing reports')}</h1>
					</div>
				</div>
				<div className="container__content-body">
					<ReportFileForm {...props}/>
					<button
						className="ui-btn ui-btn-primary apply"
						onClick={() => props.getReport('payout-reports')}>
						{props.intl('Landing reports')}
					</button>
				</div>
			</div>
		</Animate>
	),
	'view'
);

export default connect(
	state => ({
		data: selectors.getData(state),
		intl: selectors.getIntl(state),
		can: selectors.getCan(state),
		error: selectors.getError(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/landing-reports/main.js